import { inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class NavigationHistoryService {
	private readonly router = inject(Router);
	previousFullUrl: string | null = null;
	currentFullUrl: string | null = null;

	previousUrl: string | null = null;
	currentUrl: string | null = null;

	previousQueryParams: { [key: string]: string | string[] } | null = null;
	currentQueryParams: { [key: string]: string | string[] } | null = null;

	constructor() {
		this.currentFullUrl = this.router.url;
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.previousFullUrl = this.currentFullUrl;
				this.currentFullUrl = event.urlAfterRedirects;

				this.currentUrl =
					this.router
						.parseUrl(this.currentFullUrl)
						.root.children['primary']?.segments.map((segment) => segment.path)
						.join('/') || null;
				this.previousUrl =
					this.router
						.parseUrl(this.previousFullUrl || '')
						.root.children['primary']?.segments.map((segment) => segment.path)
						.join('/') || null;

				this.previousQueryParams = this.router.parseUrl(this.previousFullUrl || '').queryParams;
				this.currentQueryParams = this.router.parseUrl(this.currentFullUrl).queryParams;
			}
		});
	}
}
